
        import { Buffer } from 'https://esm.sh/buffer@6.0.3';
        window.Buffer = Buffer;
    